"use client"

import { useEffect, useRef } from "react"
import { VoiceboxProps } from "@/schemas"
import { useMeridialStore } from "@/store"
import { Button } from "@workspace/ui/components/button"
import { HugeiconsIcon } from "@hugeicons/react"
import { InformationCircleIcon } from "@hugeicons/core-free-icons"
import { Widget } from "@/components/widget"

export function Voicebox({
  onError = (error: string) => console.error("[Meridial] ", error),
  children,
  ...props
}: VoiceboxProps) {
  const keylessWarned = useRef(false)

  const setVoiceboxProps = useMeridialStore((s) => s.setProps)
  const setOpen = useMeridialStore((s) => s.setOpen)
  const open = useMeridialStore((s) => s.open)

  useEffect(() => {
    setVoiceboxProps((prev) => ({
      ...prev,
      ...props,
      onError,
      // Preserve tools/callbacks registered dynamically via `useTool`;
      // hook-registered tools win on key conflicts with prop-passed tools.
      tools: { ...props.tools, ...prev?.tools },
      toolCallbacks: prev?.toolCallbacks,
    }))
  }, [props, onError, setVoiceboxProps])

  useEffect(() => {
    if (!props.publishableKey && !keylessWarned.current) {
      keylessWarned.current = true
      useMeridialStore.getState().reportError("No publishable key provided.")
      console.warn("[Meridial] No publishable key provided.")
    }
  }, [props.publishableKey])

  return (
    <>
      {children ? (
        <button onClick={() => setOpen(true)}>{children}</button>
      ) : (
        <Button onClick={() => setOpen(true)}>
          <HugeiconsIcon icon={InformationCircleIcon} />
          Help
        </Button>
      )}
      {open && <Widget />}
    </>
  )
}
